import React, { useState, useEffect } from 'react';

import {
  Modal,
  Carousel,
  Card,
  Link,
  Video,
  Layout,
} from '@humanspace/components';
import { Colors } from '@humanspace/foundations';

import whoWeAre from '@humanspace/assets/images/who_we_are.svg';
import whatWeDo from '@humanspace/assets/images/what_we_do.svg';
import secretSauce from '@humanspace/assets/images/secret_sauce.svg';

import { LoginForm } from '../../components';

const Login = ({ login }) => {
  const [modalIsVisible, setModalIsVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('userHasClickOnLogin')) setModalIsVisible(true);
  }, []);

  return (
    <>
      <Layout
        render={
          <>
            <LoginForm
              onSubmit={({ email, password }) => login(email, password)}
            />
            <Link href="/request-password" color={Colors.anakiwa}>
              Forgot your password?
            </Link>
            <Modal
              backgroundColor={Colors.secondary}
              withoutHeader
              isVisible={modalIsVisible}
              render={
                <Carousel
                  onSkip={() => {
                    setModalIsVisible(false);
                    localStorage.setItem('userHasClickOnLogin', true);
                  }}>
                  <Card
                    element={
                      <Video
                        loop
                        autoplay
                        playsinline
                        muted
                        layerColor={Colors.secondary}
                        controls={false}
                        source="/videos/intro.mp4"
                      />
                    }
                  />
                  <Card
                    background={whoWeAre}
                    title="Who we are"
                    description="HumanSpace™ uses AI technology to help you create a workplace strategy that improves the user experience and workforce performance."
                  />
                  <Card
                    background={whatWeDo}
                    title="What we do"
                    description="We help you understand which workplace capabilities are most important to workforce performance, so you make the most of your spend on workplace."
                  />
                  <Card
                    background={secretSauce}
                    title="Our secret sauce..."
                    description="We use predictive analytics on a growing database of:- 1 million+ surveys- 12 industries- 120 countries- 50+ quantitative studies"
                  />
                </Carousel>
              }></Modal>
          </>
        }
      />
    </>
  );
};

export default Login;
